import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgAlignCenter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3 5h18M9 12h6M3 19h18"
	})
});
export default SvgKgAlignCenter;
